export enum LocalStorageRequests {
    DeviceTreeSize = "CLINK_DeviceTreeSize",
    DashboardIdOrder = "CLINK_DashboardIdOrder",
    ShowVersions = "CLINK_ShowVersions",
    ShowBalancing = "CLINK_ShowBalancing",
    GlnReporter = "CLINK_GlnReporter",
    GlnOwner = "CLINK_GlnOwner",
    AzureAccessToken = "CLINK_AzureAccessToken",
    JwtToken = "CLINK_JwtToken",
    JwtRefreshToken = "CLINK_JwtRefreshToken",
    UserOrganization = "CLINK_UserOrganization",
    DisplaySectionList = "CLINK_DisplaySectionList",
    LocaleLanguage = "CLINK_LocaleLanguage",
}

export class LocalStorageManager {
    // public static Read(key: LocalStorageRequests): string {
    //     return this._Read(key);
    // }

    // public static Write(key: LocalStorageRequests, val: string): void {
    //     this._Write(key, val);
    // }

    public static Read(key: string): string {
        const val = localStorage.getItem(key);
        return val;
    }

    public static Write(key: string, value: string) {
        localStorage.setItem(key, value);
    }

    public static Remove(key: string) {
        localStorage.removeItem(key);
    }
}
